import {Pipe, PipeTransform} from '@angular/core';
import {RatingFilter} from './filters/rating.filter';
import {LocationFilter} from './filters/location.filter';
import {SingleRatingFilter} from './filters/single-rating.filter';
import {DataSource} from './data-source';
import {FilledPercentageFilter} from './filters/filled-percentage.filter';

@Pipe({name: 'ratingFilter'})
export class RatingFilterPipe implements PipeTransform {
    private readonly ratingFilter: RatingFilter;

    constructor(ratingFilter: RatingFilter) {
        this.ratingFilter = ratingFilter;
    }

    transform(dataSource: DataSource, query: string[]): any {
        return dataSource.applyFilter(this.ratingFilter, query);
    }
}

@Pipe({name: 'singleRatingFilter'})
export class SingleRatingFilterPipe implements PipeTransform {
    private readonly singleRatingFilter: SingleRatingFilter;

    constructor(singleRatingFilter: SingleRatingFilter) {
        this.singleRatingFilter = singleRatingFilter;
    }

    transform(dataSource: DataSource, query: string): any {
        return dataSource.applyFilter(this.singleRatingFilter, query);
    }
}

@Pipe({name: 'locationFilter'})
export class LocationFilterPipe implements PipeTransform {
    private readonly locationFilter: LocationFilter;

    constructor(locationFilter: LocationFilter) {
        this.locationFilter = locationFilter;
    }

    transform(dataSource: DataSource, query: string): any {
        return dataSource.applyFilter(this.locationFilter, query);
    }
}

@Pipe({name: 'filledPercentageFilter'})
export class FilledPercentageFilterPipe implements PipeTransform {
    private readonly filledPercentageFilter: FilledPercentageFilter;

    constructor(filledPercentageFilter: FilledPercentageFilter) {
        this.filledPercentageFilter = filledPercentageFilter;
    }

    transform(dataSource: DataSource, query: string): any {
        return dataSource.applyFilter(this.filledPercentageFilter, query);
    }
}
